import angular from 'angular';

require('./lbaCompanyReferenceItemForm.scss');

const lbaCompanyReferenceItemForm = angular.module('app.lbaCompanyReferenceItemForm', []);

lbaCompanyReferenceItemForm.component('lbaCompanyReferenceItemForm', {
  bindings: {
    activeCompanyReference: '=',
    toggleDetail: '=',
    saveItem: '=',
    deleteItem: '=',
    setLoadForm: '=',
  },
  controllerAs: '$ctrl',
  controller: ['companyReferenceService', '$rootScope', lbaCompanyReferenceItemFormCtrl],
  template: require('./lbaCompanyReferenceItemForm.html')
});

function lbaCompanyReferenceItemFormCtrl(companyReferenceService, $rootScope) {
  let $ctrl = this;
  
  $ctrl.tempCompanyReference = {};
  $ctrl.saving = false;
  $ctrl.update = false;
  $ctrl.LoadForm = LoadForm;
  

 


  $ctrl.saveCompanyReference   = saveCompanyReference;
  $ctrl.deleteCompanyReference = deleteCompanyReference;
  $ctrl.updateCompanyReference = updateCompanyReference;
  $ctrl.LoadForm               = LoadForm;
  $ctrl.progressPercent = 0;
  
  $ctrl.setLoadForm($ctrl.LoadForm);
  function LoadForm(_companyReference){
    $ctrl.activeCompanyReference = _companyReference;

    $ctrl.saving = false;
    $ctrl.validationErrors=false;
    if(!$ctrl.activeCompanyReference){
      $ctrl.update=false;
      $ctrl.tempCompanyReference = {
        DebtorIdentifier:null,
        ListId:null,
        Items:[]
      };
    }else{
      $ctrl.update = true;
      angular.copy($ctrl.activeCompanyReference, $ctrl.tempCompanyReference);
    }
    CreateItemsText($ctrl.tempCompanyReference);

    
    
  }
  
  function CreateItemsText(_companyReference){
    _companyReference.ItemsText="";
    if(_companyReference.Items){
      _companyReference.Items.forEach(element => {
        _companyReference.ItemsText+=`${element.Value}, ${element.Description}\r\n`;
      });
    }
  }
  function UpdateItemsFromItemsText(_companyReference){
    let workingIndex = 0;
    _companyReference.ItemsUpdate = [];
    if(_companyReference && _companyReference.ItemsText){
        _companyReference.ItemsText.split(/\r\n|\r|\n/).forEach((line)=>{
          if(line.trim()===''){
            return;
          }
          
          let charIndex = line.indexOf(',');
          if(charIndex===-1){
            AddUpdateItem(_companyReference,line,line,workingIndex);
          }else{
            AddUpdateItem(_companyReference,line.substring(0,charIndex).trim(),line.substring(charIndex+1).trim(),workingIndex);
          }
          workingIndex++;
          
      });
    }
    
    if(_companyReference.Items &&  workingIndex<_companyReference.Items.length){
      let i = 0;
      for (i = workingIndex; i < _companyReference.Items.length; i++) {
        var existingItem = angular.copy(_companyReference.Items[i]);
        existingItem.IsDeleted=true;
        _companyReference.ItemsUpdate.push(existingItem);
      }
    }
   
  }
  function AddUpdateItem(_companyReference,Value,Description,workingIndex){
    if(_companyReference.Items && _companyReference.Items.length>workingIndex){
      //Update existing
      var existingItem = angular.copy(_companyReference.Items[workingIndex]);
      
      if(existingItem.DebtorIdentifier!==_companyReference.DebtorIdentifier
        || existingItem.ListId!==_companyReference.ListId
        || existingItem.Value!==Value
        || existingItem.Description!==Description
        || existingItem.IsDeleted===true){
            existingItem.DebtorIdentifier=_companyReference.DebtorIdentifier;
            existingItem.ListId=_companyReference.ListId;
            existingItem.Value=Value;
            existingItem.Description=Description;
            existingItem.IsDeleted = false;
            _companyReference.ItemsUpdate.push(existingItem);
      }
    }else{
      //Add New
      _companyReference.ItemsUpdate.push({
          DebtorIdentifier: _companyReference.DebtorIdentifier,
          ListId: _companyReference.ListId,
          Value: Value,
          Description: Description,
          IsDeleted: false
      });
    }
  }
  function ValidateForm(){
    $ctrl.validationErrors=false;
    if(!$ctrl.tempCompanyReference.DebtorIdentifier || !($ctrl.tempCompanyReference.DebtorIdentifier.length>0)){
      $ctrl.validationErrors=true;
    }
    if(!$ctrl.tempCompanyReference.ListId || !($ctrl.tempCompanyReference.ListId.length>0)){
      $ctrl.validationErrors=true;
    }
    return !$ctrl.validationErrors;
  }
  function saveCompanyReference(){
    
    if(!(ValidateForm()===true)){
      return;
    }
    $ctrl.saving = true;
    UpdateItemsFromItemsText($ctrl.tempCompanyReference);
    SaveBlocks($ctrl.tempCompanyReference.ItemsUpdate,0);
   
  }


  function updateCompanyReference(){
    if(!(ValidateForm()===true)){
      return;
    }
    $ctrl.saving = true;
  
    UpdateItemsFromItemsText($ctrl.tempCompanyReference);
    SaveBlocks($ctrl.tempCompanyReference.ItemsUpdate,0);
   
  }

  function SaveBlocks(items,startIndex){
    $ctrl.saving = true;
    $ctrl.showProgress = true;
    $ctrl.progressPercent = 0;
    let chunk = 100;
    
    let endIndex = (startIndex + chunk>items.length?items.length:startIndex + chunk);
    if(startIndex>=items.length){
        
        $ctrl.showProgress = false;
        $ctrl.progressPercent = 100;
        $ctrl.saving = false;
        $ctrl.toggleDetail(true);
        
        return;
    }
    let temporary = items.slice(startIndex, startIndex + chunk);
    SetProgressBar(endIndex,items.length);
    companyReferenceService.saveCompanyReferences(temporary,true).then(result=>{
     
      SaveBlocks(items,endIndex);
    });
   
  }
  function SetProgressBar(index,itemsCount){
    
    $ctrl.progressPercent = Math.floor(index/itemsCount * 100);
    $ctrl.progressStatus=`${$ctrl.progressPercent}% Saving ${index.toLocaleString()} of ${itemsCount.toLocaleString()}`;
    $ctrl.progressWidth=`{width:${$ctrl.progressPercent}%;}`;
  }



  function deleteCompanyReference(){
    $ctrl.saving = true;
    $ctrl.tempCompanyReference.ItemsUpdate = [];
    for (var i = 0; i < $ctrl.tempCompanyReference.Items.length; i++) {
      var existingItem = angular.copy($ctrl.tempCompanyReference.Items[i]);
      existingItem.IsDeleted=true;
      $ctrl.tempCompanyReference.ItemsUpdate.push(existingItem);
    }
    SaveBlocks($ctrl.tempCompanyReference.ItemsUpdate,0);

    
  }


}

export default lbaCompanyReferenceItemForm;


// WEBPACK FOOTER //
// ./src/components/lbaCompanyReferenceItemForm/lbaCompanyReferenceItemForm.js